export default {
  borderRadius: 'medium',
  paddingBottom: 'small',
  bodyGap: 'small',
  color: 'brandOne100',
  howManyPetsTitleGap: 'xSmall',
  imageTransition: 'transform 0.2s ease',
  imageTransitionHover: 'transform 0.2s ease',
  imageTransform: 'translateY(24px)',
  imageTransformHover: 'translateY(0)',
  focusWithin: 'systemFocus',
  focusOutlineColor: 'brandOne',
  objectFit: 'contain',
} as const;
